
import { View } from 'backbone';
import contentTemplate from 'properties/style/background.ejs';

class StyleBackgroundView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        return this;
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        return this;
    }

}

export default StyleBackgroundView;
